module.exports = __webpack_public_path__ + "img/defaultProductIco.b4e1cfef.png";